import * as config from '../config'
import {Align} from "../class/align";
import uuid from "uuid/v1";
import _ from "underscore";

export default class Coin {
    constructor(scene, group) {
        this.scene = scene;
        this.groupCoin = group
        this.dbCoin = {
            timeToNew: null,
            items: []
        }
    }


    generateCoin() {
        let date = new Date();
        if (_.isEmpty(this.dbCoin) || date >= this.dbCoin.timeToNew) {
            date.setSeconds(date.getSeconds() + config.projectile.coin.createdRate);
            this.dbCoin.timeToNew = date;
            let coin = this.scene.physics.add.sprite(Phaser.Math.Between(50, config.width - 50),0, 'coin');
            Align.scaleToGameW(coin, .05);
            let id = uuid();
            coin.id = id;
            this.dbCoin.items.push({
                id,
                coin
            });
            this.groupCoin.add(coin);
            coin.setGravityY(100)
        }
    }

    remove(coin) {
        let index = _.findIndex(this.scene.modelCoin.dbCoin.items, (element) => {
            return element.id === coin.id;
        });
        this.scene.groupCoin.remove(coin, true, true)
        this.scene.modelCoin.dbCoin.items.splice(index, 1)
    }

}
